<template>
  <div class="article-page__image carousel-wrapper" v-if="images.length">
    <div v-show="!isLoaded" class="loading">
      <LoaderIcon />
    </div>
    <div v-if="Array.isArray(images) && images.length > 1">
      <Carousel>
        <Slide v-for="(image, index) in images" :key="index">
          <div class="article-page__image-container">
            <transition>
              <img v-show="isLoaded" :src="image.url" alt @load="loaded" />
            </transition>
            <span class="article-page__image__caption" v-if="image.description && image.description != image.name"
              v-text="image.description"></span>
          </div>
        </Slide>

        <template #addons>
          <Navigation />
          <Pagination />
        </template>
      </Carousel>
    </div>
    <div v-else-if="Array.isArray(images) && images.length === 1">
      <img v-show="isLoaded" :src="images[0].url" alt @load="loaded" />
      <span class="article-page__image__caption" v-if="images[0].description && images[0].description != images[0].name"
        v-text="images[0].description"></span>
    </div>
  </div>
</template>

<script>
import { Carousel, Navigation, Pagination, Slide } from 'vue3-carousel'
import 'vue3-carousel/dist/carousel.css'
import LoaderIcon from "@/components/common/LoaderIcon";

export default {
  name: "ImageCarousel",
  props: ["images"],
  components: {
    LoaderIcon,
    Carousel,
    Slide,
    Pagination,
    Navigation,
  },
  data() {
    return {
      isLoaded: false
    };
  },
  methods: {

    loaded() {
      this.isLoaded = true;
    },
  }
};
</script>
<style lang="scss">
@use "~@/assets/scss/abstracts/variables" as *;
@use "~@/assets/scss/components/_carousel.scss";
.article-page__image {
  position: relative;
  padding: 0 0 2.5rem 0;
  margin-top: 0;
  width: 100%;

  &-container {
    width: 100%;
    flex: 1 100%;
  }

  img {
    max-width: 100%;
    // width: 100%;
    // max-height: 250px;
    height: auto;

    // @media screen and (min-width: $breakpoint-md) {
    //   max-height: 300px;
    // }

    // @media screen and (min-width: $breakpoint-lg) {
    //   max-height: 350px;
    // }

    // @media screen and (min-width: $breakpoint-xl) {
    //   max-height: 400px;
    // }

    // @media screen and (min-width: $breakpoint-xxl) {
    //   max-height: 400px;
    // }
  }
}
.carousel {
  &__next, &__prev {
    color: $white;
    background: $red;
    height: 100px;

    &:disabled:hover {
      background: $redDark;
      color: $white;
    }

  }
  &__icon {
    fill: $white !important;
    stroke: $white;
  }

  &__pagination {
    --vc-png-bottom: -25px;
  }
  
}
</style>